import { IFabricationMockupsState, IFabricationMockup, Types } from './types';
import { Reducer } from 'redux';

const INITIAL_SAVE_MOCKUP_STATE = {
  error: false,
  loading: false,
  success: false
};

const INITIAL_STATE: IFabricationMockupsState = {
  mockups: [],
  pavements: undefined,
  loading: false,
  contractNumber: undefined,
  error: false,
  saveMockupState: INITIAL_SAVE_MOCKUP_STATE
};

type CustomAction = {
  type: Types;
  payload: {
    mockups: IFabricationMockup[];
    mockupId: number;
    contractNumber: string;
    errorMessage: string;
    createdMockup: IFabricationMockup;
    pavementId: number;
  };
};

const reducer: Reducer<IFabricationMockupsState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.LOAD_FABRICATION_MOCKUPS:
      return {
        ...state,
        mockups: [],
        loading: true,
        error: false,
        contractNumber: action.payload.contractNumber
      };
    case Types.LOAD_FABRICATION_MOCKUPS_SUCCESS:
      return {
        ...state,
        mockups: action.payload.mockups,
        loading: false,
        error: false
      };
    case Types.LOAD_FABRICATION_MOCKUPS_FAILURE:
      return { ...state, loading: false, error: true };

    case Types.SAVE_FABRICATION_MOCKUP:
      return {
        ...state,
        saveMockupState: {
          loading: true,
          error: false,
          success: false,
          editingMockupId: action.payload.mockupId
        }
      };
    case Types.SAVE_FABRICATION_MOCKUP_SUCCESS:
      return {
        ...state,
        saveMockupState: {
          ...state.saveMockupState,
          loading: false,
          success: true
        },
        mockups: addCreatedMockup(state.mockups, action.payload.createdMockup)
      };
    case Types.SAVE_FABRICATION_MOCKUP_FAILURE:
      return {
        ...state,
        saveMockupState: {
          ...state.saveMockupState,
          loading: false,
          error: true
        }
      };

    case Types.SET_EDITING_MOCKUP:
      return {
        ...state,
        saveMockupState: {
          ...INITIAL_SAVE_MOCKUP_STATE,
          editingMockupId: action.payload.mockupId
        }
      };

    case Types.REMOVE_FABRICATION_MOCKUPS:
      return { ...state, removeMockupState: { loading: true, error: false } };
    case Types.REMOVE_FABRICATION_MOCKUPS_SUCCESS:
      return { ...state, removeMockupState: { loading: false, error: false } };
    case Types.REMOVE_FABRICATION_MOCKUPS_FAILURE:
      return { ...state, removeMockupState: { loading: false, error: true } };

    case Types.EDIT_PAVEMENT_STATUS:
      return {
        ...state,
        editPavementState: {
          editingPavementId: action.payload.pavementId,
          loading: true,
          error: false,
          success: false
        }
      };
    case Types.EDIT_PAVEMENT_STATUS_SUCCESS:
      return {
        ...state,
        editPavementState: {
          editingPavementId: action.payload.pavementId,
          loading: false,
          error: false,
          success: true
        }
      };
    case Types.EDIT_PAVEMENT_STATUS_FAILURE:
      return {
        ...state,
        editPavementState: {
          editingPavementId: action.payload.pavementId,
          loading: false,
          error: true,
          success: false
        }
      };

    default:
      return state;
  }
};

const addCreatedMockup = (
  mockups: IFabricationMockup[],
  createdMockup?: IFabricationMockup
): IFabricationMockup[] => {
  if (createdMockup) {
    return [createdMockup, ...mockups];
  } else {
    return mockups;
  }
};

export default reducer;
